import React, { useState, useEffect, Fragment } from 'react';
import {
    Nav, TabContent, TabPane, NavItem,
    Card, CardBody, Input, ButtonGroup, Button, Row, Modal,
    ModalHeader,
    ModalBody,
    CustomInput
} from 'reactstrap';

import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import {
    Separator, Colxx
} from '../../../../../components/common/CustomBootstrap';
import { active } from 'sortablejs';

export default function BubblePosition({ botSettings, saveIntegration }) {

    /** other Digital Assistant state */
    const [edit, setEdit] = useState(false);
    const [editMobile, setEditMobile] = useState(false);
    const [settings, setSetting] = useState(botSettings.bubbleSettings.bubblePosition);
    const [hideBox, setHideBox] = useState(botSettings.hideSendBox);
    const [hideBoxMobile, setHideBoxMobile] = useState(botSettings.hideSendBoxInMobile);
    const [activeTab, setActiveTab] = useState('desktop');

    const handleChange = e => {
        const value = e.target.value;
        setSetting({
            ...settings,
            [e.target.name]: value,
        });
    };

    const handleSave = () => {
        botSettings.bubbleSettings.bubblePosition = settings
        botSettings.hideSendBox = hideBox;
        botSettings.hideSendBoxInMobile = hideBoxMobile;
        if (activeTab === "desktop") {
            setEdit(!edit);
        }
        else {
            setEditMobile(!editMobile);
        }
        saveIntegration({ botSetting: botSettings });
    };

    const handleCheckChange = e => {
        if (e.target.name === "hideBoxMobile") {
            setHideBoxMobile(e.target.checked);
        }
        else {
            setHideBox(e.target.checked);
        }
    };

    const toggleMenu = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const Show = () => {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Row>
                            <Colxx sm={12} className="text-center">
                                <div className="mb-1">
                                    <b>Alignment:</b> {botSettings.bubbleSettings.bubblePosition.align}
                                </div>
                                <div className="mb-1">
                                    <b>Alignment Margin:</b> {botSettings.bubbleSettings.bubblePosition.side}px
                                </div>
                                <div className="mb-1">
                                    <b>Bottom Margin:</b> {botSettings.bubbleSettings.bubblePosition.bottom}px
                                </div>
                                <div className="mb-1">
                                    <b>Hide Typing Textbox:</b> {botSettings.hideSendBox === true ? 'Yes' : 'No'}
                                </div>
                                <Button
                                    size="xs"
                                    color="success"
                                    outline
                                    style={{ marginTop: '20px' }}
                                    onClick={() => {
                                        setEdit(!edit);
                                    }}
                                >
                                    Edit
                                </Button>
                            </Colxx>
                        </Row>
                    </Fragment>
                ) : null}
            </Fragment>
        );
    };

    function Edit() {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Row>
                            <Colxx sm={12} className="text-center">
                                <div className="mb-1">
                                    <b>Alignment</b>
                                    <br />
                                    <Input
                                        name="align"
                                        type="select"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.align}
                                        onChange={handleChange}
                                    >
                                        <option value="Left">Left</option>
                                        <option value="Right">Right</option>
                                    </Input>
                                </div>
                                <div className="mb-1">
                                    <b>Alignment Margin (px)</b>
                                    <br />
                                    <Input
                                        name="side"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.side}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-1">
                                    <b>Bottom Margin (px)</b>
                                    <br />
                                    <Input
                                        name="bottom"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.bottom}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-1">
                                    <b>Hide Typing Textbox</b>
                                    <br />
                                    <CustomInput type="checkbox" id="chkTerms" checked={hideBox} onChange={handleCheckChange} name="hideBox" />
                                </div>

                                <Separator className='mt-2 ' />

                                <div className="mb-2" style={{ marginTop: '20px' }}>
                                    <Button color="primary" size="xs" onClick={handleSave}>
                                        Save
                                    </Button>
                                    <Button
                                        size="xs"
                                        color="secondary"
                                        className='ml-2'
                                        onClick={() => {
                                            setEdit(!edit);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Colxx>
                        </Row>
                    </Fragment>
                ) : null
                }
            </Fragment >
        );
    }

    const ShowMobile = () => {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Row>
                            <Colxx sm={12} className="text-center">
                                <div className="mb-1">
                                    <b>Alignment:</b> {botSettings.bubbleSettings.bubblePosition.alignInMobile}
                                </div>
                                <div className="mb-1">
                                    <b>Alignment Margin:</b> {botSettings.bubbleSettings.bubblePosition.sideInMobile}px
                                </div>
                                <div className="mb-1">
                                    <b>Bottom Margin:</b> {botSettings.bubbleSettings.bubblePosition.bottomInMobile}px
                                </div>
                                <div className="mb-1">
                                    <b>Hide Typing Textbox:</b> {botSettings.hideSendBoxInMobile === true ? 'Yes' : 'No'}
                                </div>
                                <Button
                                    size="xs"
                                    color="success"
                                    outline
                                    style={{ marginTop: '20px' }}
                                    onClick={() => {
                                        setEditMobile(!editMobile);
                                    }}
                                >
                                    Edit
                                </Button>
                            </Colxx>
                        </Row>
                    </Fragment>
                ) : null}
            </Fragment>
        );
    };

    function EditMobile() {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Row>
                            <Colxx sm={12} className="text-center">
                                <div className="mb-1">
                                    <b>Alignment</b>
                                    <br />
                                    <Input
                                        name="alignInMobile"
                                        type="select"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.alignInMobile}
                                        onChange={handleChange}
                                    >
                                        <option value="Left">Left</option>
                                        <option value="Right">Right</option>
                                    </Input>
                                </div>
                                <div className="mb-1">
                                    <b>Alignment Margin (px)</b>
                                    <br />
                                    <Input
                                        name="sideInMobile"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.sideInMobile}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-1">
                                    <b>Bottom Margin (px)</b>
                                    <br />
                                    <Input
                                        name="bottomInMobile"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.bottomInMobile}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-1">
                                    <b>Hide Typing Textbox</b>
                                    <br />
                                    <CustomInput type="checkbox" id="chkTerms1" checked={hideBoxMobile} onChange={handleCheckChange} name="hideBoxMobile" />
                                </div>



                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    <Button color="primary" size="xs" onClick={handleSave}>
                                        Save
                                    </Button>
                                    <Button
                                        size="xs"
                                        color="dark"
                                        outline
                                        onClick={() => {
                                            setEditMobile(!editMobile);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </Colxx>
                        </Row>
                    </Fragment>
                ) : null
                }

            </Fragment >
        );
    }
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Position</h6>
                    <Separator className="mb-3" />
                </div>
                <Nav tabs className="separator-tabs ml-0 mr-0">
                    <NavItem className="w-50 text-center">
                        <NavLink
                            style={{ marginRight: "0px" }}
                            to="#"
                            location={{}}
                            className={classnames({
                                active: activeTab === 'desktop',
                                'nav-link': true,
                            })}
                            onClick={() => toggleMenu('desktop')}
                        >
                            Desktop
                        </NavLink>
                    </NavItem>
                    <NavItem className="w-50 text-center">
                        <NavLink
                            style={{ marginRight: "0px" }}
                            to="#"
                            location={{}}
                            className={classnames({
                                active: activeTab === 'mobile',
                                'nav-link': true,
                            })}
                            onClick={() => setActiveTab('mobile')}
                        >
                            Mobile
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="desktop">
                        <div className="pt-2 pr-4 pl-4 pb-2">
                            {edit ? Edit() : Show()}
                        </div>
                    </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab} >
                    <TabPane tabId="mobile">
                        <div className="pt-2 pr-4 pl-4 pb-2">
                            {editMobile ? EditMobile() : ShowMobile()}
                        </div>
                    </TabPane>
                </TabContent>
            </CardBody>

        </Card>);
}
